import { contentsSlider } from "./namespace/contentsSlider";
import { fadeInElementsOnViewport } from "./namespace/fadeInElementsOnViewport";

function interview25th() {
  const contentsCarousel = document.querySelector("#splide01");
  if (contentsCarousel) {
    contentsSlider();
  }
  fadeInElementsOnViewport();

}

export { interview25th };
